import {
  faCircleChevronDown,
  faCircleChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'antd';
import React from 'react';

type CollapsePanelProps = {
  children: React.ReactNode;
  title: React.ReactNode;
  panelKey: string;
  defaultActiveKey?: string;
};

const CollapsePanel = ({
  children,
  title,
  panelKey,
  defaultActiveKey,
}: CollapsePanelProps) => {
  return (
    <Collapse
      bordered={false}
      defaultActiveKey={defaultActiveKey ? [defaultActiveKey] : undefined}
      className="l-interpretation__collapse"
      style={{
        background: 'transparent',
      }}
      expandIcon={({ isActive }) => (
        <FontAwesomeIcon
          icon={isActive ? faCircleChevronDown : faCircleChevronRight}
          size={'2x'}
          rotate={isActive ? 90 : 0}
          className={`l-interpretation__collapse-icon ${
            isActive ? 'l-interpretation__collapse-icon--active' : ''
          }`}
        />
      )}
    >
      <Collapse.Panel
        key={panelKey}
        header={title}
        style={{
          padding: 0,
        }}
      >
        {children}
      </Collapse.Panel>
    </Collapse>
  );
};

export default CollapsePanel;
